<template>
	<div id="app">
		<app-header v-if="$route.meta.index != 1&& this.$route.name!='customized'"></app-header>
		<keep-alive :include="keepAlive">
		    <router-view />
		</keep-alive>
          <app-fooder v-if="$route.meta.showFooter"></app-fooder>
	</div>
</template>

<script>
	import appHeader from "@/components/header.vue";
	import appFooder from "@/components/appFooder.vue";

	export default {
		name: 'App',
		data(){
			return {
				keepAlive:["home"],
			}
		},
		components: {
			appHeader,
			appFooder
		},
		watch: { //监听路由变化
			$route(to, from) {

				window.scroll(0, 0);
				
				document.title = to.meta.title;

			}
		},

		mounted() {

			this.getIndex();


		},
		computed: {
			
		},
		methods: {

			getIndex() {

				var app = this;

				this.$api("/index/contact", {},"GET").then(function(res) {
					
					app.$store.dispatch('SET_CONTACT', res.data);
					

				})
			},
		}
	}
</script>


<style lang="less">
     @import "./assets/css/login.less";

     body .el-button--info{
    	background-color: #000;
        border-color: #000;
    }

</style>







// WEBPACK FOOTER //
// src/App.vue